import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

export const presentationSchema = z.object({
  title: z.string().min(3),
  link: z.string(),
  volumeName: z.string(),
  conference: identitySchema,
  authors: z.array(authorSchema).min(1),
});

export const defaultPresentationValues: DefaultValues<PresentationSchema> = {
  title: '',
  link: '',
  volumeName: '',
  authors: [],
};

export type PresentationSchema = z.infer<typeof presentationSchema>;
